import { ApiService } from "../../../config";
import { handleError } from "../../../utils/parseApiReturn";
import { toast } from "react-toastify";

const changePassword = async (
  currentPassword: string,
  newPassword: string,
  confirmPassword: string,
): Promise<boolean> => {
  try {
    // ApiService injeta o Bearer do usuario logado automaticamente.
    const res = await ApiService.post("/users/me/change-password", {
      currentPassword,
      newPassword,
      confirmPassword,
    });
    const { error, message } = res.data;
    if (error) {
      toast.error(message);
      return false;
    }
    toast.success(message || "Senha alterada com sucesso");
    return true;
  } catch (error: any) {
    const { message } = handleError(error, "Erro ao alterar a senha.");
    toast.error(message);
    return false;
  }
};

export const AccountService = {
  changePassword,
};
